const baseUrls = {
  dev: process.env.REACT_APP_API_BASE_URL_DEV,
  uat: process.env.REACT_APP_API_BASE_URL_UAT,
  test: process.env.REACT_APP_API_BASE_URL_TEST,
};

export const getBaseUrl = () => {
    const hostname = window.location.hostname;
    if (hostname.includes('localhost') || hostname.includes('test')) {
        return baseUrls.test;
    } else if (hostname.includes('uat')) {
        return baseUrls.uat;
    } else if (hostname.includes('dev')) {
        return baseUrls.dev;
    }
};
